/**
 * Teksty drogi firmy wspólne dla rejestracji (`pages/Signup.jsx`) i pulpitu (`components/rynek/AnkietaNaStart.jsx`).
 *
 * TEKST_FIRMA_MA_KONTO (2026-10-24): firma o tym NIP-ie ma już konto (`ma_konto` z wyszukania NIP-u,
 * `firma_oczekujaca.zajeta` w profilu). NIP nie dopisuje do cudzej firmy, dołącza się przez zaproszenie. Wcześniej
 * druga osoba z tym samym NIP-em dostawała po potwierdzeniu adresu konto bez firmy i bez słowa.
 */
export const TEKST_FIRMA_MA_KONTO = 'Ta firma ma już konto w VoltValue. Do jej zespołu dołączysz z zaproszenia: '
  + 'poproś o nie osobę, która prowadzi konto firmy, na ten sam adres e-mail.'
